import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

export const addUserModalStateValid = (state: Types.ModalData): boolean =>
  !RasaInput.validateEmail(state.email).invalid

const NOPE: Types.PersonRole = {
  id: '',
  is_active: false,
  name: '',
}
export const getPersonRoles = (roles: Types.PersonRole[], allRoles: Types.Role[]): Types.PersonRole[] => {
  return (allRoles || []).map((role: Types.Role) => ({
    id: role.name,
    is_active: roles.filter((r: Types.PersonRole) => r.id === role.name).concat(NOPE)[0].is_active,
    name: role.description,
  }))
}



// WEBPACK FOOTER //
// ./src/pages/users/utils.ts